import React, { Component } from 'react';
import '../../App.css';

import Modal from 'react-responsive-modal';
import request from 'request-promise-native';

import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Form from 'react-bootstrap/lib/Form';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import Button from 'react-bootstrap/lib/Button';
import HelpBlock from "react-bootstrap/lib/HelpBlock";
import ProgressBar from "react-bootstrap/lib/ProgressBar";
import Alert from "react-bootstrap/lib/Alert";
import ValidatedFormComponent from "../ValidatedFormComponent";
import {Row} from "react-bootstrap";

const GENERATE_REPORT_ENDPOINT = "https://qibipay.azurewebsites.net/api/GetSalesReport";

const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
]

class GenerateReportModal extends Component {
    constructor(props) {
        /*
            Props:
             - access_code
             - open
             - onClose
             - logout
             - regId?
             - deviceName?
        */
        super(props);

        this.state = {
            errors: {

            },

            loading: false,
            success: false
        }

        this.currentMonth = new Date().getUTCMonth();
    }

    async submit() {
        if(this.monthRef.validated()) {
            const val = parseInt(this.monthRef.value);

            let year = new Date().getUTCFullYear();
            if(val>this.currentMonth) {
                year--;
            }

            const timestampFrom = new Date(year, val, 0, 0, 0, 0, 0);
            const timestampTo = new Date(val+1>=12 ? year+1 : year, (val+1)%12, 0, 0, 0, 0, 0);

            this.setState({loading: true, errors:{}, errorMessage:null});

            const options = {
                method: 'POST',
                uri: GENERATE_REPORT_ENDPOINT,
                body: {
                    access_code: this.props.access_code,
                    timestampFrom: timestampFrom.getTime(),
                    timestampTo: timestampTo.getTime(),
                    regId: this.props.regId
                },
                json: true,
                resolveWithFullResponse: true,
                simple: false
            };

            const response = await request(options);

            this.setState({loading: false});

            if(response.statusCode===404) {
                this.props.logout();
                return;
            }

            if(response.statusCode===400) {
                this.setState({errorMessage: response.body.msg});
                return;
            }

            if(response.statusCode!==200) {
                this.setState({errorMessage: 'Server error occured, please retry.'});
                return;
            }

            const csvHeader = ["\"Date\"", "\"Type\"", "\"Amount\"", "\"Description\"","\"Device name\"", "\"Device ID\""].join(",")+"\n";
            const csvData = response.body.data
                .map(e => [
                    "\""+new Date(e.timestamp).toUTCString()+"\"",
                    "\""+e.src+"\"",
                    "\""+e.amount.toFixed(2)+"\"",
                    "\""+e.description+"\"",
                    "\""+e.deviceName+"\"",
                    "\""+e.regId+"\""
                ].join(",")).join("\n");

            const resultString = csvHeader+csvData;

            const url = window.URL.createObjectURL(new Blob([resultString], {
                type: 'text/csv'
            }));
            const a = document.createElement('a');
            a.style.display = 'none';
            a.href = url;
            // the filename you want
            a.download = "sales_report_"+(this.props.deviceName==null ? "" : this.props.deviceName+"_")+months[val]+"_"+year+".csv";
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            this.setState({
                success: true
            });
        }
    }

    reset() {
        this.setState({
            errors: {

            },

            loading: false,
            success: false
        });
        this.props.onClose();
    }

    render() {

        const showMonths = [this.currentMonth, (this.currentMonth+12-1)%12, (this.currentMonth+12-2)%12].map(index => {
            return {
                value: index,
                displayName: months[index]
            }
        });

        return(
            <Modal open={this.props.open} onClose={this.reset.bind(this)} styles={{
                modal: {
                    minWidth: "450px"
                }
            }} >
                <h2>Generate sales report</h2>

                {this.state.errorMessage!=null ? (<Alert bsStyle="danger">
                    <strong>{this.state.errorMessage}</strong>
                </Alert>) : ''}

                {this.state.loading ? (
                    <div>
                        <p>Generating report...</p>
                        <ProgressBar  active now={100}/>
                    </div>
                ) : this.state.success ? (
                    <div>
                        <p>Report generated successfully!</p>
                        <p>File was automatically downloaded</p>
                    </div>
                ) : (
                    <Form horizontal style={{
                        marginLeft: "32px",
                        marginRight: "32px"
                    }}>
                        <ValidatedFormComponent name="Month"
                                                type="select"
                                                options={showMonths}
                                                value_key={"value"}
                                                display_name_key={"displayName"}
                                                onChange={(val) => {
                                                    this.setState({
                                                        month: val
                                                    })
                                                }}
                                                onValidate={() => null}
                                                value={this.state.month}
                                                inputRef={ref => this.monthRef=ref}
                        />
                        <Col sm={4}/>
                            <Col sm={8}>
                            <Button bsStyle="primary" onClick={this.submit.bind(this)}>
                                Generate
                            </Button>
                        </Col>
                    </Form>
                )}
            </Modal>
        );
    }

}

export default GenerateReportModal;